const AssignFromType = {
  FROM_REQUEST_SENT: 1,
  NORMAL: 2
}
export default AssignFromType
